import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TransactionImportSuccessProps {
  readonly count: number;
  readonly systemName: string;
  readonly onViewAssets: () => void;
  readonly importedTransactionIds: string[];
}

export function TransactionImportSuccess({
  count,
  systemName,
  onViewAssets,
  importedTransactionIds,
}: Readonly<TransactionImportSuccessProps>) {
  return (
    <div className="bg-white dark:bg-black rounded-2xl shadow-xl shadow-slate-200/50 dark:shadow-slate-800/50 p-12 max-w-md w-full">
      <div className="text-center space-y-6">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-emerald-100 dark:bg-emerald-900/30 rounded-full flex items-center justify-center">
          <CheckCircle2 className="w-10 h-10 text-emerald-600 dark:text-emerald-400" />
        </div>

        {/* Success Message */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
            Assets Created Successfully!
          </h2>
          <p className="text-slate-600 dark:text-slate-400">
            {count} {count === 1 ? 'asset has' : 'assets have'} been created from transactions in {systemName}
          </p>
        </div>

        {/* Stats */}
        <div className="bg-slate-50 dark:bg-slate-900 rounded-xl p-6 space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-slate-600 dark:text-slate-400">Assets Created</span>
            <span className="text-lg font-semibold text-slate-900 dark:text-slate-100">{count}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-slate-600 dark:text-slate-400">Source</span>
            <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{systemName}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-slate-600 dark:text-slate-400">Transactions Used</span>
            <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{importedTransactionIds.length}</span>
          </div>
        </div>

        {/* Action Button */}
        <Button
          onClick={onViewAssets}
          className="w-full"
          size="lg"
        >
          View Created Assets
        </Button>

        {/* Additional Info */}
        <p className="text-xs text-slate-500 dark:text-slate-400">
          The new assets are now available in your asset register and will appear in reports and depreciation calculations.
        </p>
      </div>
    </div>
  );
}

export default TransactionImportSuccess;
